import type { TagResponseDto } from '@/api/generated/api'
import { CardGrid } from './CardGrid'
import { TagCard } from './TagCard'

interface TagsSectionProps {
  tags?: TagResponseDto[]
}

export function TagsSection({ tags = [] }: TagsSectionProps) {
  return (
    <CardGrid
      items={tags}
      emptyState={{
        icon: (
          <svg
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            />
          </svg>
        ),
        emoji: '🏷️',
        title: 'No tags yet',
        description: 'Create tags to organize your moves',
      }}
      renderCard={tag => <TagCard tag={tag} />}
      getItemLink={tag => `/tags/${tag.id}`}
      getItemKey={tag => tag.id}
    />
  )
}
